var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-popup"},[_c('PopUp',{attrs:{"pop-up-active":_vm._popupActive,"notice":"","clickOutsideClose":false,"title":_vm._popupTitle},on:{"click":function($event){return _vm.$_popupClose()}}},[_c('LlCancelPopupContent',{attrs:{"cancel-text":_vm._popupContent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }